import { Component, Input, OnInit } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { SagaObject } from '@models/imported/SagaBase/SagaObject';
import { TranslateService } from '@ngx-translate/core';
import { ToolsProvider, ToolsProviderService } from '@services/tools';
import { StampNameProviderService } from '../../services/stamp-name-provider/stamp-name-provider.service';
import { StampTextProviderService } from '../../services/stamp-text-provider/stamp-text-provider.service';

@Component({
  selector: 'app-journal-item',
  templateUrl: './journal-item.component.html',
  styleUrls: ['./journal-item.component.scss']
})
export class JournalItemComponent implements OnInit {
  @Input() item: SagaObject;
  @Input() isNew: boolean;
  @Input() showUserName?: boolean = true;

  stampIcon: string;
  stampName: string;
  stampText: string;

  toolIcon: string;
  toolsProvider: ToolsProvider;

  isExpanded: boolean = false;

  constructor(
    private stampNameProvider: StampNameProviderService,
    private stampTextProvider: StampTextProviderService,
    private toolsProviderService: ToolsProviderService,
    private actionSheet: ActionSheetController,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.stampIcon = this.item.icon;
    this.stampName = this.stampNameProvider.getStampName(this.item);
    this.stampText = this.stampTextProvider.getStampText(this.item);

    this.toolsProvider = this.toolsProviderService.getToolsForContext(this.item);
    if (this.toolsProvider.tools.length > 0) {
      this.toolIcon = this.toolsProvider.tools.length > 1 ? 'more' : this.toolsProvider.tools[0].icon;
    }
  }

  onSelect() {
    this.isExpanded = !this.isExpanded;
  }

  onToolClicked($event) {
    $event.stopPropagation();
    $event.preventDefault();

    if (this.toolsProvider.tools.length === 1) {
      this.toolsProvider.tools[0].execute([this.item]);
    } else {
      const buttons = this.toolsProvider.getActionSheetButtons(true);
      if (buttons.length > 1) {
        this.actionSheet
          .create({
            header: this.translate.instant(this.toolsProvider[0].$t),
            buttons
          })
          .then(actionSheet => actionSheet.present());
      }
    }
  }
}
